<template>
  <div>
    <Breadcrumb origin-name="Organisations" origin-path="/organisations" :current-name="organisation.name" />
    <h3>Admins verwalten</h3>
    <List :columns="columns" :values="admins" emptyText="Bisher keine Admins vorhanden">
      <template #column_name="{data}">{{ data.firstName }} {{ data.lastName }}</template>
      <template #column_action="{data}">
        <div class="d-flex justify-content-center">
          <img @click="adminToDelete = data" src="../../assets/icons/remove.svg" />
        </div>
      </template>
    </List>
    <button @click="$router.push('admins/add')" class="btn btn-primary">Admin hinzufügen</button>
    <Dialog :visible="adminToDelete"
            title="Admin entfernen?"
            ok-button-text="Ja, entfernen!"
            @cancel="adminToDelete = undefined"
            @ok="removeAdmin"
            :message="`Wollen Sie ${adminToDelete ? adminToDelete.firstName : ''} ${adminToDelete ? adminToDelete.lastName : ''} wirklich entfernen?`">
    </Dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/partial/Breadcrumb.vue";
import {communicator} from "@/util/communicator";
import {broadcast} from "@/util/eventHandler";
import List from "@/components/partial/List.vue";
import Dialog from "@/components/partial/Dialog.vue";

export default {
  components: {Dialog, List, Breadcrumb},
  name: "Admins",
  data() {
    return {
      adminToDelete: undefined,
      admins: [],
      organisation: [],
      columns: [
        { name: "Name", key: "name" },
        { name: "E-Mail Adresse", key: "email" },
        { name: "Aktion", key: "action", styles: { width: "75px" } },
      ]
    };
  },
  created() {
    if(this.$route.params.id) {
      this.loadAdmins(this.$route.params.id);
      this.organisation = this.$store.state.organisations.find(e => String(e.id) === this.$route.params.id);

    }
  },
  methods: {
    async loadAdmins(id) {
      try {
        const response = await communicator.get("/organisations/" + id + "/admins");
        this.admins = response.data.items;
      } catch (e) {
        broadcast("error", e.response.data);
      }
    },
    async removeAdmin() {
      if(!this.adminToDelete) return;
      try {
        await communicator.delete("/organisations/" +  this.$route.params.id + "/admins/" + this.adminToDelete.id);
        this.adminToDelete = undefined;
        this.loadAdmins(this.$route.params.id);
      } catch (e) {
        broadcast("error", e.response.data);
      }
    }
  }
};
</script>

<style lang="scss">
.d-flex img:hover {
  cursor: pointer;
}
</style>
